import { Component, OnInit } from '@angular/core';
import Highcharts from 'highcharts';
// tslint:disable:variable-name
@Component({
  selector: 'app-projection-calculator',
  templateUrl: './projection-calculator.component.html',
  styleUrls: ['./projection-calculator.component.scss']
})
export class ProjectionCalculatorComponent implements OnInit {
  active = 0;
  denefitsTotal: any;
  lenderTotal: any;
  gain = 0;
  monthDisplay = '1 month';
  labels = ['Profit from Denefits', 'Profit from Lenders'];
  colors = ['#3791E5', '#38C6DC'];
  amount = {
    min: 100,
    max: 30000,
    step: 50,
    value: 100
  };
  patient = {
    min: 1,
    max: 100,
    step: 1,
    value: 1
  };
  interest = {
    min: 1,
    max: 100,
    step: 0.25,
    value: 10
  };
  month = {
    min: 1,
    max: 60,
    step: 1,
    value: 1
  };
  data_calc = {
    avg_plan: 2000,
    down_payment: 0,
    avg_term: 24,
    comp_interest: 15,
    plan_growth: 5,
    terms_array: 12
  };
  denefits10Total: any;
  data = [0, 0];
  plan_list: any[];
  count = 0;
  denefit_monthly_revenue = [];
  cc_full_monthly_revenue = [];
  cc_half_monthly_revenue = [];
  terms_array: any[];
  revenue;
  aMchartData: any[] = [];
  selectedData = {};
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions;
  languageFormatted = {
    en: {
      series_name: 'Other Financing Platforms with 50% Approval.',
      text: 'Monthly Earnings',
      months: 'Months',
      earnings: 'Earnings'
    },
    fr: {
      series_name: 'Autres plateformes de financement avec 50% d\'approbation.',
      text: 'Gains mensuels',
      months: 'Mois',
      earnings: 'Gains'
    },
    de: {
      series_name: 'Andere Finanzierungsplattformen mit 50% Zustimmung.',
      text: 'Monatliches Einkommen',
      months: 'Monate',
      earnings: 'Verdienste'
    },
    it: {
      series_name: 'Altre piattaforme di finanziamento con approvazione del 50%.',
      text: 'Guadagno mensile',
      months: 'Mesi',
      earnings: 'Guadagni'
    },
    es: {
      series_name: 'Otras Plataformas de Financiamiento con 50% de Aprobación.',
      text: 'Ingresos mensuales',
      months: 'Meses',
      earnings: 'Ganancias'
    },
    pl: {
      series_name: 'Inne platformy finansowe z 50% aprobatą.',
      text: 'Miesięczne zarobki',
      months: 'Miesiące',
      earnings: 'Zyski'
    },
    ja: {
      series_name: '50% の承認を得たその他の金融プラットフォーム',
      text: '月収',
      months: '月',
      earnings: '収益'
    },
    'zh-CN': {
      series_name: '其他融资平台获得50%批准。',
      text: '每月收入',
      months: '几个月',
      earnings: '收益'
    },
    'zh-TW': {
      series_name: '其他融資平台獲得50%批准。',
      text: '每月收入',
      months: '幾個月',
      earnings: '收益'
    }
  };
  monthsArray = [12, 24, 36, 48, 60];
  selectedTbas = 0;
  customMonth: any;
  showAddBox = false;
  implementationPeriod = 1;
  cost_of_waiting: any;
  cost_of_waiting_type = 0;
  viewType = 'graph';
  maxImplementationPeriod = 360;
  denefit_monthly_revenue_61_months = [];
  constructor() { }

  ngOnInit() {
    this.resetCalc();
    this.getCostOfwaiting();
  }

  resetCalc() {
    this.data_calc = {
      avg_plan: 2000,
      down_payment: 0,
      avg_term: 24,
      comp_interest: 15,
      plan_growth: 5,
      terms_array: 12
    };
    this.showAddBox = false;
    this.selectedTbas = 0;
    this.implementationPeriod = 1;
    this.maxImplementationPeriod = 360;
    this.calculateCalc(true);
  };


  public calculate() {
    var month = this.month.value % 12;
    var year = (this.month.value - month) / 12;
    this.monthDisplay = (year ? year + (year == 1 ? ' Year ' : ' Years ') : '') + (month ? (month == 1 ? month + ' month' : month + ' months') : '');
    this.denefitsTotal = this.compFunc(this.amount.value, this.interest.value, this.month.value);
    this.denefitsTotal > 0 ? this.denefitsTotal = this.denefitsTotal : this.denefitsTotal = 0;
    this.denefits10Total = this.compFunc(this.amount.value, this.interest.value, this.month.value);
    this.denefits10Total > 0 ? this.denefits10Total = this.denefits10Total : this.denefits10Total = 0;
    var lenderSI = ((this.amount.value * 15) / 100);
    this.lenderTotal = this.amount.value - lenderSI;
    this.denefitsTotal *= (this.patient.value * this.month.value);
    this.denefits10Total *= (this.patient.value * this.month.value);
    this.lenderTotal *= (this.patient.value * this.month.value);
    this.denefitsTotal *= 0.9;
    this.gain = (Number(this.denefitsTotal)) - (Number(this.lenderTotal));
    this.data = [this.denefitsTotal.toFixed(2), this.lenderTotal.toFixed(2)];
    this.calculateCalc(false)
  };


  public compFunc = function (p, r, t) {
    var ci = (p * (Math.pow((1 + (r / 1200)), (t)))).toFixed(2);
    return ci;
  };

  public calculateCalc(update) {
    this.terms_array = [];
    this.aMchartData = [];
    let basic = this.data_calc;
    if (this.data_calc && this.data_calc.terms_array)
      this.plan_list = new Array(this.data_calc.terms_array).fill('');
    let index = 0;
    for (var i = 1; i <= this.data_calc.terms_array; i++) {
      this.terms_array.push(i);
    }
    for (let plan of this.plan_list) {
      if (index === 0) {
        this.plan_list[index] = {
          new_plans: basic.plan_growth,
          residual_plan: 0,
          drop_off_plan: 0,
          total_plans: basic.plan_growth
        };
      } else {
        let prev_plan = this.plan_list[index - 1];
        let drop_off = 0;
        if (basic.avg_term < index + 1) {
          drop_off = this.plan_list[index - basic.avg_term].new_plans
        }
        this.plan_list[index] = {
          new_plans: basic.plan_growth,
          residual_plan: prev_plan.total_plans,
          drop_off_plan: drop_off,
          total_plans: prev_plan.total_plans + basic.plan_growth - drop_off,
        };
      }
      index++;
    }
    this.plan_list.forEach(plan => {
      let loan_amount = (basic.avg_plan * (1 - (basic.down_payment / 100)));
      let total_p_i = (loan_amount * (1 + (basic.comp_interest / 100) / 12) ** basic.avg_term)
      let revenue = total_p_i / basic.avg_term;
      let dp = 0;
      let denefits_monthly = (((revenue * plan.residual_plan) + dp) * 0.9);
      let full_care_credit = ((basic.avg_plan * plan.new_plans - dp) * 0.85);
      let half_care_credit = (full_care_credit / 2);
      plan.denefit_patient_plan = {
        down_payment: dp,
        amount: denefits_monthly
      };
      plan.full_care_credit = {
        down_payment: dp,
        amount: full_care_credit
      }
      plan.half_care_credit = {
        down_payment: dp,
        amount: half_care_credit
      }
    });
    this.denefit_monthly_revenue = [];
    this.denefit_monthly_revenue_61_months = [];
    this.denefit_monthly_revenue = this.plan_list.map(plan => JSON.parse(parseFloat(plan.denefit_patient_plan.amount).toFixed(2)));
    this.cc_full_monthly_revenue = this.plan_list.map(plan => parseFloat(plan.full_care_credit.amount).toFixed(2));
    this.cc_half_monthly_revenue = this.plan_list.map(plan => JSON.parse(parseFloat(plan.half_care_credit.amount).toFixed(2)));


    // --- New 61-month plan calculation ---
    const plan_list_61 = new Array(61).fill('');
    const extended_terms_array_61 = [];
    let index61 = 0;
    const basic2 = this.data_calc;

    for (let i = 1; i <= 61; i++) {
      extended_terms_array_61.push(i);
    }

    for (let plan of plan_list_61) {
      if (index61 === 0) {
        plan_list_61[index61] = {
          new_plans: basic2.plan_growth,
          residual_plan: 0,
          drop_off_plan: 0,
          total_plans: basic2.plan_growth
        };
      } else {
        let prev_plan = plan_list_61[index61 - 1];
        let drop_off = 0;
        if (basic2.avg_term < index61 + 1) {
          drop_off = plan_list_61[index61 - basic2.avg_term].new_plans;
        }

        plan_list_61[index61] = {
          new_plans: basic2.plan_growth,
          residual_plan: prev_plan.total_plans,
          drop_off_plan: drop_off,
          total_plans: prev_plan.total_plans + basic2.plan_growth - drop_off,
        };
      }
      index61++;
    }
    const denefit_monthly_revenue_61 = [];

    plan_list_61.forEach(plan => {
      const loan_amount = (basic2.avg_plan * (1 - (basic2.down_payment / 100)));
      const total_p_i = (loan_amount * Math.pow(1 + (basic2.comp_interest / 100) / 12, basic2.avg_term));
      const revenue = total_p_i / basic2.avg_term;
      const dp = 0;

      const denefits_monthly = (((revenue * plan.residual_plan) + dp) * 0.9);
      denefit_monthly_revenue_61.push(parseFloat(denefits_monthly.toFixed(2)));
    });
    this.denefit_monthly_revenue_61_months = denefit_monthly_revenue_61;
    this.terms_array.forEach((dataset) => {
      if (dataset.label == 'Denefits') {
        dataset.data = this.denefit_monthly_revenue;
      }
      if (dataset.label == 'Care Credit with 50% Approval') {
        dataset.data = this.cc_half_monthly_revenue;
      }
      if (dataset.label == 'Care Credit with 100% Approval') {
        dataset.data = this.cc_full_monthly_revenue;
      }
    });
    this.maxImplementationPeriod = this.denefit_monthly_revenue.length * 30;
    this.getData(this.denefit_monthly_revenue, this.terms_array, this.cc_half_monthly_revenue);
    this.getCostOfwaiting();
  };

  getSize(type, min, max) {
    let percentage = 50;
    if (type) {
      let value;
      if (type == 1) {
        value = this.data_calc.avg_plan;
      } else if (type == 2) {
        value = this.data_calc.avg_term;
      } else if (type == 3) {
        value = this.data_calc.comp_interest;
      } else if (type == 4) {       
        value = this.data_calc.plan_growth;
      }
      else if (type == 5) {
        value = this.data_calc.terms_array;
      }
      percentage = ((((value + (type == 1 ? 125 : type == 4 ? 2.5 : 0)  + 0.8 ) - min) / (max - min)) * 100);
    }

    return [`polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0% 100%)`, `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`];
  }

  getData(data1, data2, data3) {

    this.chartOptions = {
      chart: {
        type: 'column',
      },
      title: {
        text: this.selectedData['text']
      },
      xAxis: {
        tickLength: 0, // turn off default vertical ticks
        lineColor: '#FFFFFF',
        lineWidth: 1,

        categories: data2,
        title: {
          text: this.selectedData['months'],
          style: {
            color: 'black',
          }
        }
      },
      yAxis: {
        tickLength: 10,
        tickWidth: 1,
        tickColor: '#FFFFFF',
        title: {
          text:  'Monthly Recurring Revenue ($)',
          style: {
            color: '#A2A8B0',
            fontSize:'19px',
            marginBottom:'12px'
          }, 
          align: 'middle',
          margin: 30

        },
        labels: {
          format: '{value}'
        },
        lineColor: '#FFFFFF',
        lineWidth: 1,
        gridLineColor: '#2A2E39'
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
          events: {
            legendItemClick: function () {
              return false;
            }
          },
          tooltip: {
            valuePrefix: '$',
            useHTML: true,
            backgroundColor: '#fff',
            borderColor: '#00FFE0',
            style: {
              color: '#FFFFFF',
              fontSize: '14px'
            },
          }
        }
      },
      series: [
        {
          type: 'column',
          name: 'Earnings',
          showInLegend: false,
          data: data1,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // 90deg
            stops: [
              [0, '#00FFFF'],
              [0.504, '#00FF4D']
            ]
          },
        }
      ]
    };
  }

  setMonthValue(value: any) {
    this.data_calc.terms_array = value;
    this.calculateCalc(true);
    this.showAddBox = false;
  }

  enforceMinMax() {
    const min = 3;
    const max = 60;
    const val = Number(this.customMonth);
    if(!this.customMonth){return;}
    if (val < min) {
      this.customMonth = min;
    } else if (val > max) {
      this.customMonth = max;
    }
  }

  enforceMinMaxPeriod() {
    const min = 1;
    const max = this.cost_of_waiting_type ? 60 : 1800;
    const val = Number(this.implementationPeriod);
    console.log(max, '>>>>>>>>>>');
    if(!this.implementationPeriod){return;}
    if (val < min) {
      this.implementationPeriod = min;
    } else if (val > max) {
      this.implementationPeriod = max;
    }
    this.getCostOfwaiting();
  }

  getCostOfwaiting() {
    if(this.cost_of_waiting_type && this.implementationPeriod > 60 || !this.cost_of_waiting_type && this.implementationPeriod > 1800){
      return;
    }
    // const maxValue = this.denefit_monthly_revenue_61_months.length * 30;
    // this.implementationPeriod = value > maxValue ? maxValue : value;
    // const data = this.getIndex(this.implementationPeriod);
    // const value1 = (this.denefit_monthly_revenue_61_months[data.index]/data.days)*this.implementationPeriod;
    let calculateVal = 0;
    // tslint:disable-next-line:max-line-length
    calculateVal  = (this.data_calc.avg_plan * this.data_calc.plan_growth) / 30 * (this.implementationPeriod * (this.cost_of_waiting_type ? 30 : 1));
    this.cost_of_waiting = calculateVal.toFixed(2);
  }
  onSelecDropDown(value: any) {
    this.cost_of_waiting_type = Number(value);
    this.enforceMinMaxPeriod();
  }


  getIndex(days: number): { index: number; days: number } {
    if (days <= 60) { return { index: 2, days: 60 }; }
    const index = Math.ceil(days / 30);
    const maxIndex = this.denefit_monthly_revenue_61_months.length - 1;
    return {
      index: Math.min(index, maxIndex),
      days: index * 30
    };
  }

  hide(){
    if(this.showAddBox) {
      this.showAddBox = false;
    }
  }


}
